'use client';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Button, Typography } from '@mui/material';

import { PALETTE_KEYS } from '@/constants/theme.constants';

interface WithdrawalSuccessProps {
  txHash: string | null;
  onBack: () => void;
}

export const WithdrawalSuccess = ({ txHash, onBack }: WithdrawalSuccessProps) => (
  <Box sx={{ textAlign: 'center', py: 4 }}>
    <CheckCircleOutlineIcon sx={{ fontSize: 80, color: PALETTE_KEYS.SUCCESS_MAIN, mb: 2 }} />
    <Typography variant="h4" fontWeight={700} color={PALETTE_KEYS.TEXT_PRIMARY} sx={{ mb: 1 }}>
      Successful!
    </Typography>
    <Typography variant="body1" color={PALETTE_KEYS.TEXT_SECONDARY} sx={{ mb: 4 }}>
      The crypto transfer has been submitted. Onramper will now process your fiat payout.
    </Typography>

    {txHash && (
      <Box
        sx={{
          mb: 4,
          p: 2,
          bgcolor: 'success.bg',
          borderRadius: 2,
          textAlign: 'left',
        }}
      >
        <Typography
          variant="caption"
          color={PALETTE_KEYS.TEXT_SECONDARY}
          sx={{ display: 'block', mb: 0.5 }}
        >
          Transaction Hash
        </Typography>
        <Typography
          variant="body2"
          color={PALETTE_KEYS.SUCCESS_MAIN}
          sx={{ wordBreak: 'break-all', fontFamily: 'monospace', fontSize: '0.75rem' }}
        >
          {txHash}
        </Typography>
      </Box>
    )}

    <Button
      variant="outlined"
      fullWidth
      size="large"
      onClick={onBack}
      sx={{
        py: 2,
        borderRadius: 2,
        color: PALETTE_KEYS.TEXT_PRIMARY,
        borderColor: PALETTE_KEYS.DIVIDER,
        fontWeight: 600,
        '&:hover': { borderColor: PALETTE_KEYS.TEXT_PRIMARY },
      }}
    >
      Back to Portfolio
    </Button>
  </Box>
);
